import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    snapshots: {},
    lastResourceId: {},
    sideBarEditView: '',
    lstWaResourceId: '',
};
const slice = createSlice({
    name: 'customerCardReducer',
    initialState,
    reducers: {
        updateSnapshot(state, action) {
            const { snapshot, key } = action.payload;
            state.snapshots[key] = snapshot;
        },
        removeKey(state, action) {
            delete state.snapshots[action.payload];
        },
        updateLastResourceId(state, action) {
            const { email, id } = action.payload;
            state.lastResourceId[email] = id;
        },
        updateWaLstWaResourceId(state, action) {
            state.lstWaResourceId = action.payload;
        },
    },
});
export const CustomerCardActions = slice.actions;
export default slice.reducer;
